



























































import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { propertyGroup, ParamsInfo } from '@/api/property/propertyGroup'
import Pagination from '@/components/Pagination/index.vue'
import { CommonDataModule } from '@/store/modules/commonData'

@Component({
  components: {
    Pagination
  }
})
export default class PropertyGroup extends Vue {
  private groupList: any[] = []
  private groupTotal: number = 0
  private orgInfo: any[] = []
  private paramsInfo: ParamsInfo = {
    groupName: '',
    wyOrganizationName: '',
    wyOrganizationId: this.$Cookies.get('wyOrganizationId'),
    pageNum: 1,
    pageSize: 10
  }
  private dialogVisible: boolean = false
  private dialogTextType = ''
  private dialogInfo: ParamsInfo = {
    groupId: 0,
    groupName: '',
    wyOrganizationName: '',
    wyOrganizationId: ''
  }
  private rules = {
    groupName: [{ required: true, message: '请输入姓名', trigger: 'change' }],
    wyOrganizationId: [{ required: true, message: '请选择组织', trigger: 'change' }]
  }
  private async created() {
    this.orgInfo = await CommonDataModule.getOrganizations('property')
    this.fetchData()
    this.queryTotal()
  }

  private async fetchData() {
    const response: any = await propertyGroup('GET', this.paramsInfo, null, '/Page')
    this.groupList = response
  }
  private async queryTotal() {
    let params = Object.assign({}, this.paramsInfo)
    delete params.pageNum
    delete params.pageSize
    const response: any = await propertyGroup('GET', params, null, '/Count')
    this.groupTotal = response
  }
  private async handleSearch() {
    this.paramsInfo.pageSize = 10
    this.paramsInfo.pageNum = 1
    this.fetchData()
    this.queryTotal()
  }

  private handleCreate() {
    this.dialogVisible = true
    this.dialogTextType = '新增组'
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
      this.dialogInfo.wyOrganizationId = this.$Cookies.get('wyOrganizationId') ? Number(this.$Cookies.get('wyOrganizationId')) : ''
    })
  }
  private handleUpdate(rowData: any) {
    this.dialogVisible = true
    this.dialogTextType = '编辑组'
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
      this.dialogInfo.groupId = rowData.id
      this.dialogInfo.groupName = rowData.name
      this.dialogInfo.wyOrganizationName = rowData.wyOrganization.name
      this.dialogInfo.wyOrganizationId = rowData.wyOrganizationId
    })
  }
  // 提交操作
  private submitCreateData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        const submitData: any = Object.assign({}, this.dialogInfo)
        delete submitData.groupId
        propertyGroup('POST', submitData, null).then( (response) => {
          this.fetchData()
          this.queryTotal()
          this.$message.success('新增组成功')
          this.dialogVisible = false
        })
        .catch((err) => {
          this.$message.error(`${err}`)
        })
      }
    })
  }
  private submitEditData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        propertyGroup('PUT', this.dialogInfo, null, '/Information').then( (response: any) => {
          this.fetchData()
          this.queryTotal()
          this.$message.success('编辑成功')
          this.dialogVisible = false
        })
      }
    })
  }
  // 调整组内人员
  private goDetail(rowData: any) {
    this.$router.push( {
      name: 'groupDetail',
      path: `/propertyInfo/group/groupDetail`,
      query: { groupId: rowData.id, wyOrganizationId: rowData.wyOrganizationId }
    })
  }
  // 删除
  private handleDetele(rowData: any) {
    this.$confirm(`此操作将把 ${rowData.name} 该保洁组移除, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      propertyGroup('DELETE', null, [rowData.id]).then( res => {
        this.$message({ type: 'success',  message: '删除成功!' })
        this.fetchData()
        this.queryTotal()
      })
    }).catch(() => {
      this.$message({ type: 'info', message: '已取消删除' })
    });
  }
}
